export default (config) => {
  const {
    netlib,
    apiWrap,
  } = config;

  const changePassword = (password, passwordCheck, onSuccessCb, onErrorCb) => apiWrap({
    apiQueryCb: () => netlib.AuthApi.changePassword(password, passwordCheck),
    apiErrorCb: (err, showError) => {
      onErrorCb();
      showError();
    },
    apiSuccessCb: onSuccessCb,
  });

  const logout = (socialLogin = false) => apiWrap({
    apiQueryCb: () => netlib.LoginUtils.doLogout(socialLogin),
  });

  const refreshToken = () => apiWrap({ apiQueryCb: netlib.LoginUtils.doRefresh });

  return {
    changePassword,
    logout,
    refreshToken,
  };
};
